import { useState, useEffect } from 'react'
import { useGlobalStore } from '../context'

export const useInsightsEnabled = () => {
  const { isInitialized, appDataStore } = useGlobalStore()
  const [insightsEnabled, setInsightsEnabled] = useState(false)

  useEffect(() => {
    if (isInitialized && appDataStore.clientInsightProfile?.is_enabled) {
      setInsightsEnabled(true)
    }
  }, [isInitialized, appDataStore.clientInsightProfile])

  return insightsEnabled
}
